import { console } from 'react-redux-app/lib/modules/core/utils';
import { handleOnEnterException } from 'react-redux-app/lib/modules/routing/utils';

import { actionInitExchangeRatesForEurRequest } from '../../../init/actions/exchangeRatesForEur';
import { actionInitSiteDataRequest } from '../../../init/actions/initData';

import { INTERNAL_ERROR_URI } from 'react-redux-app/lib/modules/routing/constants';
import { maybeHandleCriticalError } from 'react-redux-app/lib/modules/api/utils';

import { getInitDataError } from '../../../init/selectors/initData';
import { getAreTranslationsLoaded } from 'react-redux-app/lib/modules/i18n/selectors';

import {
  getExchangeRatesForEurError,
  getExchangeRatesForEur,
} from '../../../init/selectors/exchangeRatesForEur';


export default ({ getState, dispatch }) => (
  function initHandler(nextState, successCallback, errorCallback) {
    Promise.all([
      dispatch(actionInitSiteDataRequest()),
      dispatch(actionInitExchangeRatesForEurRequest()),
    ]).then(
      () => {
        if (handleOnEnterException(getState(), errorCallback, INTERNAL_ERROR_URI)) {
          return;
        }

        const initDataError = getInitDataError(getState());
        if (
          initDataError
          && maybeHandleCriticalError(
            nextState.location, initDataError.globalErrors, errorCallback
          )
        ) {
          return;
        }

        const exchangeRatesForEurError = getExchangeRatesForEurError(getState());
        if (
          exchangeRatesForEurError
          && maybeHandleCriticalError(
            nextState.location, exchangeRatesForEurError.globalErrors, errorCallback
          )
        ) {
          return;
        }

        if (getExchangeRatesForEur(getState()) && getAreTranslationsLoaded(getState())) {
          successCallback();
          return;
        }

        console.consoleError(
          `initHandler. Unable to initialize application. Make redirect to ${INTERNAL_ERROR_URI}`
        );
        errorCallback(INTERNAL_ERROR_URI);
      }
    ).catch(error => {
      console.consoleError('initHandler failed', error);
      errorCallback(INTERNAL_ERROR_URI);
    });
  }
);
